module.exports = __webpack_public_path__ + "static/media/Asset 57.09d1079e.jpg";